import { useEffect, useState } from "react";
import { chatDesignSchema, createDesignCss } from "../../shared/chat-design";
import { publicApiBase } from "../public-path";

export function PublishedDesign() {
  const [css, setCss] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const response = await fetch(`${publicApiBase()}/design`, { cache: "no-store", signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        const result = chatDesignSchema.safeParse(data.design);
        if (result.success) setCss(createDesignCss(result.data));
      } catch { /* A design outage must not prevent an inquiry. Keep the current UI. */ }
    }
    void load();
    window.addEventListener("focus", load);
    return () => { controller.abort(); window.removeEventListener("focus", load); };
  }, []);
  return css ? <style data-published-design>{css}</style> : null;
}
